import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../modules/infra/i18n';
import * as shapes from '../shapes';
import CancelButtonLink from '../containers/CancelButtonLink';

const Footer = ({ pristine, invalid, baseUrl, handleDelete, isDeletable }) => (
  <div>
    <div className="c-separator u-mv" />
    <div className="u-text-right">
      <button
        display-if={isDeletable}
        type="button"
        onClick={handleDelete}
        className="c-btn c-btn--red u-width-120 u-mr-"
      >
        <span className="c-btn__text">{t('settings:taxes.footer.delete')}</span>
      </button>
      <CancelButtonLink link={baseUrl} content={t('settings:taxes.footer.cancel')} />
      <button
        type="submit"
        className="c-btn u-width-120"
        disabled={pristine || invalid}
      >
        <span className="c-btn__text">{t('settings:taxes.footer.save')}</span>
      </button>
    </div>
  </div>
);

Footer.propTypes = {
  pristine: shapes.pristine,
  invalid: shapes.invalid,
  baseUrl: PropTypes.string.isRequired,
  handleDelete: PropTypes.func,
  isDeletable: PropTypes.bool,
};

Footer.defaultProps = {
  previousPage: () => null,
  pristine: true,
  invalid: false,
  handleDelete: null,
  isDeletable: false,
};
export default Footer;
